class UserSelectionRequest {
    constructor(title='', text='', select=((e)=>(console.log(e))), dismiss=((e)=>(console.log(e))), choices=[]) {
        this.title = title
        this.text = text
        this.select = select
        this.dismiss = dismiss
        this.choices = choices
    }
}

export default UserSelectionRequest


// WEBPACK FOOTER //
// ./src/models/UserSelectionRequest.js